import React from 'react';
import './About.css'
import about from '../../../images/about_me.png'

const About = () => {
    return (
        <div>
        <section className="AboutMe">
            <div className="">
                <div className="row">
                    <div className="col-md-4 d-flex align-items-center">
                        <img className="aboutImg mt-5 img-fluid" src={about} alt="" />
                    </div>
                    <div className="col-md-8 mt-5 rightAbout">
                        <div className="rightContent">
                            <h1 className="aboutTitle">About Me</h1>
                            <span className="aboutSubtitle">MERN Stack Web Developer</span>
                            <p>I'm a MERN-Stack Developer with Industry Experience building Websites and Web Applications.I specialize in JavaScript and have professional experience working with React, Node.js, MongoDB, and Typescript. I consider myself a good honest hard working MEAN .</p>
                            

                            <p>I also have experience in developing static websites Desing using HTML5, CSS3 and JavaScript (ES6). I am a quick learner. I believe in hard work and efficiency. That's why I am always ready to accomplish any task by working hard. I always focus on learning new technology. My goal is to become A World-Class Professional Web Developer.</p>

                            <p>MERN Stack developer with more than 1 year of Experience, Designing, Developing, Databases. I can write as Both Front-End and Back-End. I also monitor and process pull requests for production deployments.</p>
                        </div>
                        <div className="row mt-2">
                            <div className="col-md-6 mt-2">
                                <div className="age">
                                    <strong className="mr-5">Age</strong>
                                    <span>20</span>
                                </div>
                                <div className="address">
                                    <strong className="mr-3">Address</strong>
                                    <span>Dhanmondi, Dhaka 1209</span>
                                </div>
                                <div className="email">
                                    <strong className="mr-4">Email</strong>
                                    <span>sajjadDev@gmail.com</span>
                                </div>
                            </div>
                            <div className="col-md-6 mt-2 ">
                                <div className="phone">
                                    <strong className="mr-4">Phone</strong>
                                    <span>+88018 6084 3454</span>
                                </div>
                                <div className="website">
                                    <strong className="mr-4">Website</strong>
                                    <span>www.sajjadDev.com</span>
                                </div>
                                <div className="country">
                                    <strong className="mr-4">Country</strong>
                                    <span>Bangladeshi</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </div>
    );
};

export default About;